import React from "react";
import ProductCard from "./ProductCard";

const RelatedProducts = ({ relatedProducts, onCartSuccess, onCartError }) => {
  return (
    <div className="container-fluid mt-5">
      <h3 style={{ fontSize: "1.5rem", color: "#212121", marginBottom: "20px", textAlign:"center" }}>
        Related Products
      </h3>
      <div className="row justify-content-center align-item-center w-auto ms-0 me-0">        
        {relatedProducts.length > 0 ? (
          relatedProducts.map((product) => (
            // <div key={product.id} className="col-xl-4 col-md-6">
                <ProductCard
                  key={product.id}
                  product={product}
                  onCartSuccess={onCartSuccess}
                  onCartError={onCartError}
                  // col={"col-xxl-4 col-lg-4"}
                />
            // </div>
          ))
        ) : (
          // <p>No related products available.</p>
          null
        )}
      </div>
    </div>
  );
};

export default RelatedProducts;